import PermissionsPage from 'modules/permissions/pages/settings/PermissionsPage'

const PermissionsIndexRootPage = () => {
  return <PermissionsPage />
}

export default PermissionsIndexRootPage
